// Kiddio brand logo: rounded sky-blue square with a winking face + GPS spark,
// plus the "KIDDIO" wordmark (I's in sky blue, letters slightly rotated).

function Isotype({ size = 44 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden="true">
      <rect x="6" y="6" width="88" height="88" rx="28" fill="#2E9EF0" stroke="#12263A" strokeWidth="6" />
      {/* left eye: closed wink arc */}
      <path d="M24 48 q9 -11 18 0" stroke="#12263A" strokeWidth="6" strokeLinecap="round" fill="none" />
      {/* right eye: open round */}
      <circle cx="64" cy="45" r="7.5" fill="#12263A" />
      <circle cx="67" cy="42" r="2.4" fill="#FFFFFF" />
      {/* smile: ascending */}
      <path d="M30 62 q16 16 34 -3" stroke="#12263A" strokeWidth="6" strokeLinecap="round" fill="none" />
      {/* GPS spark, 4-pointed */}
      <path
        d="M83 12 L86 22 L96 25 L86 28 L83 38 L80 28 L70 25 L80 22 Z"
        fill="#12263A"
      />
    </svg>
  );
}

const LETTERS = [
  { c: "K", color: "#12263A", r: -3 },
  { c: "I", color: "#2E9EF0", r: 2 },
  { c: "D", color: "#12263A", r: -2 },
  { c: "D", color: "#12263A", r: 3 },
  { c: "I", color: "#2E9EF0", r: -3 },
  { c: "O", color: "#12263A", r: 2 },
];

export default function Logo({ size = 44, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="kiddio-logo">
      <Isotype size={size} />
      {showText && (
        <span className="flex" style={{ fontFamily: '"Archivo Black", sans-serif' }}>
          {LETTERS.map((l, i) => (
            <span
              key={i}
              style={{
                color: l.color,
                transform: `rotate(${l.r}deg)`,
                fontSize: `${size * 0.62}px`,
                lineHeight: 1,
                letterSpacing: "-0.02em",
              }}
            >
              {l.c}
            </span>
          ))}
        </span>
      )}
    </div>
  );
}
